import DeepDiff from 'deep-diff'

const state = {
  returnRoute: {},
  baseIndex: 0,
  currentIndex: 0,
  snapshots: [],
  saving: false,
  hasError: false
}

const getters = {
  returnRoute: state => state.returnRoute,
  snapshots: (state) => state.snapshots,
  baseSnapshot: (state) => state.snapshots[state.baseIndex],
  currentSnapshot: (state) => state.snapshots[state.currentIndex],
  snapshotDiff: (state) => {
    if (state.snapshots[state.baseIndex] && state.snapshots[state.currentIndex]) {
      return DeepDiff.diff(state.snapshots[state.baseIndex], state.snapshots[state.currentIndex])
    } else {
      return null
    }
  },
  hasError: (state) => state.hasError,
  saving: (state) => state.saving
}

const actions = {
  clearSnapshots({ commit }) {
    commit('clearSnapshots')
  },
  saveInitialSnapshots({ commit }, entity) {
    commit('saveInitialSnapshots', entity)
  },
  saveSnapshot({ commit }, entity) {
    commit('saveSnapshot', entity)
  },
  setReturnRoute({ commit }, route) {
    commit('setReturnRoute', route)
  },
  setSavingStatus({ commit }, status) {
    commit('switchSavingStatus', status)
  },
  setErrorStatus({ commit }, status) {
    commit('switchErrorStatus', status)
  }
}

const mutations = {
  clearSnapshots(state) {
    state.baseIndex = 0
    state.currentIndex = 0
    state.snapshots = []
  },
  saveInitialSnapshots(state, payload) {
    state.snapshots = []
    state.snapshots[0] = payload.entity
    state.snapshots[1] = payload.entity
    state.baseIndex = 0
    state.currentIndex = 1
  },
  saveSnapshot(state, payload) {
    state.snapshots.splice(state.currentIndex, 1, payload.entity)
  },
  setReturnRoute(state, route) {
    state.returnRoute = route
  },
  switchErrorStatus(state, status) {
    state.hasError = status
  },
  switchSavingStatus(state, status) {
    if (status) {
      state.hasError = false
    }
    state.saving = status
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

